import React, { useEffect, useState } from "react";
import { Logo } from "../components/Title/logo";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

const Invoice = () => {
  const [id, setId] = useState(null);
  const [payment, setPayment] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const value = queryParams.get("id");
    if (value) setId(value);
  }, [location.search]);


  useEffect(() => {
    if (id) {
      axios
        .get(`${process.env.REACT_APP_DONATE}/payment/${id}`)
        .then((response) => {
          if (response) {
            setPayment(response.data);
          }
        });
    }
  }, [id]);

  const handleContinue = () => {
    navigate("/closing");
  };
  const handleDownload = () => {
    if (id) {
      axios
        .get(`${process.env.REACT_APP_DONATE}/invoice/${id}`)
        .then((response) => {
          console.log(response)
          if(response.data.link){
            window.open(response.data.link,'_blank')
          }
        })
          .catch((error)=>{
            console.log(error)
          })

    }
  };

  if (payment) {
    return (
      <div className="w-screen sm:w-[500px] min-w-[340px] mx-auto bg-backgroundLightGrey">
        <div className="flex flex-col items-center h-screen mx-auto px-4 relative disable ">
          <Logo />
          <div className="pr-12 mt-4 ml-4">
            <div className="font-bold text-left text-[24px]">Your Invoice</div>
          </div>
          <div className="min-w-screen container bg-lightBlack rounded-xl shadow-xl mb-4 mt-8 border-2 border-black">
            <div className="px-6 py-3">
              <div className="font-bold underline">
                <div className="py-4 mt-4 flex flex-row justify-end">
                  <img
                    src="/images/Logo_large.svg"
                    layout="fixed"
                    width="30%"
                    height="19px"
                    alt="Payjim Icon"
                  />
                </div>
              </div>
            </div>
            <div className="px-6 py-3">
              <div className="font-bold underline">Billed to</div>
              <div>
                {payment.user.first} {payment.user.last}
              </div>
              <div>
                {payment.address.street} {payment.address.number}
              </div>
              <div>
                {payment.address.postalCode} {payment.address.city}
              </div>
              <div>{payment.address.countryCode}</div>
            </div>
            <div className="px-6 py-3 float-right">
              <div>
                <b>
                  <u>Invoice Date</u>
                </b>{" "}
                : {new Date(payment.timestamp).toLocaleString()}
              </div>

              <div>
                <b>
                  <u>Performance Date</u>
                </b>{" "}
                : {new Date(payment.timestamp).toLocaleString()}
              </div>
              <div>
                <b>
                  <u>Invoice Number</u>
                </b>{" "}
                : {payment.uuid}
              </div>
            </div>

            <div className="mt-24 px-6 py-3">
              <div className="font-bold underline">
                Dear {payment.user.first} {payment.user.last},
              </div>
              <div>
                we thank you for the payment and the trust you put into our
                company.
              </div>
            </div>
            <div className="px-6 py-3 flex flex-row">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 text-xs font-bold text-left text-gray-500 uppercase "
                    >
                      Pos
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-xs font-bold text-left text-gray-500 uppercase "
                    >
                      Description
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-xs font-bold text-left text-gray-500 uppercase "
                    >
                      Price (€)
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  <tr>
                    <td className="px-6 py-4 text-sm font-medium text-gray-800 whitespace-nowrap">
                      {payment.item.id}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-800 whitespace-nowrap">
                      {payment.item.name}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-800 whitespace-nowrap">
                      {payment.item.amount}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-6 py-3">
              <hr
                style={{
                  float: "right",
                  width: "50%",
                  borderTop: "3px solid #bbb",
                }}
              />
            </div>
            <div style={{ width: "50%" }} className="px-6 py-3 float-right">
              <div style={{ fontSize: 16 }}>
                <div style={{ float: "left", width: "50%", padding: 5 }}>
                  Subtotal
                </div>
                <div style={{ float: "left", width: "50%", padding: 5 }}>
                  {(Math.round(payment.total * 100) / 100).toFixed(2)}
                </div>
              </div>
              <div style={{ fontSize: 24, color: "darkorange" }}>
                <div style={{ float: "left", width: "50%", padding: 5 }}>
                  Total
                </div>
                <div style={{ float: "left", width: "50%", padding: 5 }}>
                  {(Math.round(payment.total * 100) / 100).toFixed(2)}
                </div>
              </div>
            </div>
            <div className="mt-24 px-6 py-3">
              <div className="font-bold underline">Best regards,</div>
              <div>Your PAYJIM - Team</div>
            </div>
            <div className="px-6 py-3">
              <hr
                style={{
                  float: "right",
                  width: "100%",
                  borderTop: "3px solid #bbb",
                }}
              />
            </div>
            <div className="px-6 py-3 font-bold underline">
              PayJim UG (haftungsbeschränkt)
            </div>
            <div className="px-6 py-3">
              <div style={{ content: "", display: "table", clear: "both" }}>
                <div style={{ float: "left", width: "50%", padding: 10 }}>
                  <div>Wendl-Dietrich-Str. 18</div>
                  <div>80634 München</div>
                  <div>Deutschland</div>
                  <div>Vat-ID: DE1234567</div>
                </div>
                <div style={{ float: "left", width: "50%", padding: 10 }}>
                  <div>Jim Kuhn & Farokh Dayyani & Cagatay Akin Baser</div>
                  <div>Tel: +49 (0) 89 200012800</div>
                  <div>Email: kontakt@payjim.de</div>
                  <div>www.payjim.de</div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ content: "", display: "table", clear: "both" }}>
            <div style={{ float: "left", width: "50%", padding: 5 }}>
              <button
                className="bg-white text-black border-b-gray-900 font-bold pr-12 pl-12 pt-4 pb-4  rounded-xl shadow-xl mt-8 mb-4  mr-4 text-left"
                onClick={handleDownload}
              >
                Download
              </button>
            </div>
            <div style={{ float: "left", width: "50%", padding: 5 }}>
              <button
                className="bg-orange text-white pr-12 pl-12 pt-4 pb-4  rounded-xl shadow-xl mt-8 mb-4  mr-4 text-left"
                onClick={handleContinue}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  } else
    return (
      <div className="w-screen sm:w-[500px] min-w-[340px] mx-auto bg-backgroundLightGrey">
        <div className="flex flex-col items-center h-screen mx-auto px-4 relative disable ">
          <Logo />
          <div className="pr-12 mt-4 ml-4">
            <div className="font-bold text-left text-[24px]">
              Invoice Not Found
            </div>
          </div>
        </div>
      </div>
    );
};
export default Invoice;
